import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { getTopDenunciantes } from '../api/informesApi'

export const useTopDenunciantes = (trigger, contrato) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!trigger || !contrato) return

    const controller = new AbortController()

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await getTopDenunciantes(contrato, { signal: controller.signal })
        const mapped = response.data.map((row) => ({
          ...row,
          activo: row.activo ? 'Si' : 'No',
        }))
        setData(mapped)
      } catch (error) {
        if (error.name === 'CanceledError') return
        Sentry.captureException(error)
        setData([])
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
    return () => controller.abort()
  }, [trigger, contrato])

  return { data, isLoading, error }
}
